export enum ChartType {
  likert = 'likert',
  distribution = 'distribution',
  likertDistribution = 'likertDistribution',
  scatter = 'scatter',
}
